import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { RxMethods } from '../../services/rxjs.service';

@Injectable()
export class ModifiedUserService implements OnDestroy {

  userDetails: Subject<any>;
  modifiedUserInfo: object;

  constructor(private rxMethods: RxMethods) {
  }

  setUserDetailsAsSubject() {
    this.userDetails = this.rxMethods.createSubjectService();
  }

  setUserSource(modifiedDetails: any) {
    const userData = this.modifiedUserData(modifiedDetails);
    this.userDetails.next(userData);
  }
  setUserSourcePlanList(modifiedDetails: any) {
    this.modifiedUserData(modifiedDetails);
  }

  modifiedUserData(response) {
    const modifiedUserValue = {
      created_by: response.strCreatedBy,
      created_date: response.dtCreatedDate,
      modified_by: response.strModifiedBy,
      modified_date: response.dtModifiedDate
    };
    this.modifiedUserInfo = modifiedUserValue;
    return modifiedUserValue;
  }

  getModifiedUser() {
    return this.modifiedUserInfo;
  }

  ngOnDestroy(): void {
    this.userDetails.unsubscribe();
  }
}


